<template>
  <b-row>
    <div class="col-md-12">
      <card class="stacked-form">
        <form v-on:submit.prevent="doSubmit">

          <fg-input :required="true" for-input="name" type="text" name="name" id="name" label="Name" placeholder="Enter Name" v-validate="modelValidations.name" :error="errors.first('name')" data-vv-as="Name" v-model="model.name"/>

          <fg-input label="Kategori" class="mb-3">
            <treeselect 
              v-model="model.category" 
              class="mb-3" 
              placeholder="Pilih kategori" 
              :multiple="false"
              :clear-on-select="true"
              :options="categoryList" 
              name="category"
              data-vv-as="category" ></treeselect>
          </fg-input>
          <b-row class="border ml-0 mr-0 mb-5 mt-3" v-for="(line, index) in lines" v-bind:key="index">
            <b-col md="5">
              <fg-input label="Warna">
                <treeselect 
                  v-model="line.color" 
                  class="mb-3" 
                  placeholder="Pilih warna" 
                  :multiple="false"
                  :clear-on-select="true"
                  :options="colorList" 
                  name="color"
                  data-vv-as="color" ></treeselect>
              </fg-input>
            </b-col>
            <b-col md="5">
              <fg-input label="Ukuran">
                <treeselect 
                  v-model="line.size" 
                  class="mb-3" 
                  placeholder="Pilih ukuran" 
                  :multiple="true"
                  :clear-on-select="true"
                  :options="sizeList"
                  @input="getData(line.size, index)"
                  name="size"
                  data-vv-as="size" ></treeselect>
              </fg-input>
            </b-col>
            <b-col md="1 p-0 mt-4-5 text-center">
              <button @click="removeLine(index)" v-if="index >= 1" class="btn btn-danger"><i class="fa fa-times"></i></button>
            </b-col>
            <b-col md="1 p-0 mt-4-5 text-center">
              <b-button type="button" v-if="index + 1 === lines.length" @click="addLine" variant="primary" ><font-awesome-icon icon="plus"/></b-button>
            </b-col>
            <b-col md="12">
              <b-row v-for="(lineSize, lineIndex) in line.model" :key="lineIndex">
                <b-col md="12">
                  <b-row>
                    <b-col md="4 pl-4">
                      <fg-input :required="true" for-input="capitalPrice" type="number" name="capitalPrice" id="capitalPrice" label="Harga Beli" placeholder="Enter Name" v-model="lineSize.capitalPrice" :error="errors.first('capitalPrice')" data-vv-as="harga beli"/>
                    </b-col>
                    <b-col md="4">
                      <fg-input :required="true" for-input="sellingPrice" type="number" name="sellingPrice" id="sellingPrice" label="Harga Jual" placeholder="Enter Name" v-model="lineSize.sellingPrice" :error="errors.first('sellingPrice')" data-vv-as="harga jual"/>
                    </b-col>
                    <b-col md="4">
                      <fg-input :required="true" for-input="memberPrice" type="number" name="memberPrice" id="memberPrice" label="Harga Member" placeholder="Enter Name" v-model="lineSize.memberPrice" :error="errors.first('memberPrice')" data-vv-as="harga member"/>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4 pl-4">
                      <fg-input :required="true" for-input="smPrice" type="number" name="smPrice" id="smPrice" label="Harga spesial member" placeholder="Enter Name" v-model="lineSize.smPrice" :error="errors.first('smPrice')" data-vv-as="harga sepesial member"/>
                    </b-col>
                    <b-col md="4">
                      <fg-input :required="true" for-input="more3" type="number" name="more3" id="more3" label="Harga lebih dari 3" placeholder="Enter Name" v-model="lineSize.more3" :error="errors.first('more3')" data-vv-as="harga lebih dari 3"/>
                    </b-col>
                    <b-col md="4">
                      <fg-input :required="true" for-input="more12" type="number" name="more12" id="more12" label="Harga lebih dari 12" placeholder="Enter Name" v-model="lineSize.more12" :error="errors.first('more12')" data-vv-as="harga lebih dari 3"/>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4 pl-4">
                      <fg-input :required="true" for-input="dropshipper" type="number" name="dropshipper" id="dropshipper" label="Harga dropshipper" placeholder="Enter Name" v-model="lineSize.dropshipper" :error="errors.first('dropshipper')" data-vv-as="harga dropshipper"/>
                    </b-col>
                    <b-col md="4">
                      <fg-input :required="true" for-input="gold_member" type="number" name="gold_member" id="gold_member" label="Harga gold member" placeholder="Enter Name" v-model="lineSize.gold_member" :error="errors.first('gold_member')" data-vv-as="harga gold member"/>
                    </b-col>
                    <b-col md="4">
                      <fg-input :required="true" for-input="stock" type="number" name="stock" id="stock" label="Stok" placeholder="Enter Name" :error="errors.first('stock')" v-model="lineSize.stock" data-vv-as="Stok"/>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <cancel-button/>

          <save-data-button :disabled="saveButtonData.isLoading" :is-create="$route.params.id === undefined" :state="saveButtonData.isLoading && saveButtonData.state === 1 ? 2 : saveButtonData.state" :is-loading="saveButtonData.isLoading"/>
          
        </form>
      </card>
    </div>
  </b-row>
</template>
<script>
  import { DatePicker, Select, Option, Switch } from 'element-ui'
  import { Radio } from '@/components/index'
  import SaveData from '@/components/Buttons/SaveData'
  import Cancel from '@/components/Buttons/Cancel'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  export default {
    components: {
      SaveDataButton: SaveData,
      CancelButton: Cancel,
      [Option.name]: Option,
      [Select.name]: Select,
      [DatePicker.name]: DatePicker,
      LRadio: Radio,
      LSwitch: Switch,
      Treeselect
    },
    data () {
      return {
        downPaymentDisabled: true,
        saveButtonData: {
          isLoading: false,
          state: 1
        },
        apiUrl: {
          product: window.AppConfig.apiUrl + 'product',
          categroy: window.AppConfig.apiUrl + 'category',
          color: window.AppConfig.apiUrl + 'color',
          size: window.AppConfig.apiUrl + 'size'
        },
        lines: [{
          color: null,
          size: [],
          model: []
        }],
        blockRemoval: true,
        categoryList: [],
        colorList: [],
        sizeList: [],
        model: {
          name: '',
          category: null,
          color: null,
          size: []
        },
        modelValidations: {
          name: {
            required: true
          },
          category: {
            required: true
          },
          color: {
            required: true
          },
          size: {
            required: true
          }
        }
      }
    },
    watch: {
      lines () {
        this.blockRemoval = this.lines.length <= 1
      }
    },
    mounted () {
      this.initData()
      this.getCategory()
      this.getColor()
      this.getSize()
      // this.addLine()
    },
    methods: {
      initData () {
        if (this.$route.params.id !== undefined) {
          this.getDetail()
        }
      },
      getData (value, indexRow) {
        if (value.length <= this.lines[indexRow].model.length) {
          // removeItem()
          this.lines[indexRow].model.pop()
        } else {
          this.lines[indexRow].model.push({
            sizeId: value[value.length - 1],
            capitalPrice: 0,
            sellingPrice: 0,
            memberPrice: 0,
            smPrice: 0,
            more3: 0,
            more12: 0,
            dropshipper: 0,
            gold_member: 0,
            stock: 0
          })
        }
        // console.log(this.model.size)
      },
      addLine () {
        // let checkEmptyLines = this.lines.filter(line => line.color === null)
        // if (checkEmptyLines.length >= 1 && this.lines.length > 0) return
        this.lines.push({
          color: null,
          size: [],
          model: []
        })
      },
      removeLine (lineId) {
        if (!this.blockRemoval) this.lines.splice(lineId, 1)
      },
      getDetail () {
        this.isLoading = true
        this.$http.get(this.apiUrl.product + '/' + this.$route.params.id)
        .then(response => {
          this.model.name = response.data.name
          this.model.email = response.data.email
          this.model.phone = response.data.phone
          this.model.address = response.data.address
          this.model.village = response.data.village
          this.model.districts = response.data.districts
          this.model.city = response.data.city
          this.model.postalCode = response.data.postalCode
          this.model.personInCharge = response.data.personInCharge
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
          // this.$router.push('/notfound')
        })
      },
      getCategory () {
        this.$http.get(this.apiUrl.categroy + '?limit=100').then(response => {
          response.data.data.forEach(data => {
            this.categoryList.push({
              id: data.id,
              label: data.name
            })
          })
        })
      },
      getColor () {
        this.$http.get(this.apiUrl.color + '?limit=100').then(response => {
          response.data.data.forEach(data => {
            this.colorList.push({
              id: data.id,
              label: data.name
            })
          })
        })
      },
      getSize () {
        this.$http.get(this.apiUrl.size + '?limit=100').then(response => {
          response.data.data.forEach(data => {
            this.sizeList.push({
              id: data.id,
              label: data.name
            })
          })
        })
      },
      doSubmit () {
        this.$validator.validateAll().then(res => {
          if (res) {
            this.saveButtonData.isLoading = true
            console.log(this.lines)
            let model = {
              name: this.model.name,
              productCategory: {
                category: this.model.category,
                productColor: []
              }
            }
            this.lines.forEach((line, index) => {
              model.productCategory.productColor.push({
                color: line.color,
                productSize: []
              })
              line.model.forEach(productSize => {
                model.productCategory.productColor[index].productSize.push({
                  size: productSize.sizeId,
                  capitalPrice: productSize.capitalPrice,
                  sellingPrice: productSize.sellingPrice,
                  memberPrice: productSize.memberPrice,
                  smPrice: productSize.smPrice,
                  more3: productSize.more3,
                  more12: productSize.more12,
                  dropshipper: productSize.dropshipper,
                  gold_member: productSize.gold_member,
                  stock: productSize.stock
                })
              })
            })
            this.$http.post(this.apiUrl.product, model).then(response => {
              this.saveButtonData.isLoading = false
              this.$store.dispatch('notification/success', 'User has been added.')
              window.location.href = document.URL.replace('/create', '/' + response.data.id)
            }).catch(error => {
              this.saveButtonData.isLoading = false
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      },
      formatNumber (num) {
        return 'Rp. ' + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',-'
      }
    }
  }
</script>

<style scooped>
  .fixed-top-selling {
    position: fixed;
    float: right !important;
    /* top: 0; */
    /* right: 0; */
    /* left: 0; */
    width: 37%;
  }
  .fixed-top-downpayment {
    position: fixed;
    float: right !important;
    top: 48%;
    /* right: 0; */
    /* left: 0; */
    width: 37%;
  }
  .mt-4-5 {
    margin-top: 2rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Products/Form.vue